import React from 'react'
import UpdateYourLinkedinPageOne from './UpdateYourLinkedinPageOne'
import UpdateYourLinkedinPageTwo from './UpdateYourLinkedinPageTwo'
import UpdateYourLinkedinPageThree from './UpdateYourLinkedinPageThree'

const UpdateYourLinkedinExercise = ({ section }) => {
  return (
    <div className="flex flex-col gap-4">
      {section === 0 && <UpdateYourLinkedinPageOne />}
      {section === 1 && <UpdateYourLinkedinPageTwo />}
      {section === 2 && <UpdateYourLinkedinPageThree />}
    </div>
  )
}

export default UpdateYourLinkedinExercise
